import React, { useMemo } from "react";
import { FiSearch } from "react-icons/fi";
import { ArrowUpIcon } from "../../../helper/HwIcon";

const uniqueValues = (data, key) =>
  Array.from(new Set(data?.map((d) => d[key]).filter(Boolean) || []));

const ErrorFilters = ({ data, filters, onChange }) => {
  const vendors = useMemo(() => uniqueValues(data, "vendor"), [data]);
  const modules = useMemo(() => uniqueValues(data, "module"), [data]);
  const severities = useMemo(() => uniqueValues(data, "severity"), [data]);
  const statuses = useMemo(() => uniqueValues(data, "status"), [data]);

  const update = (patch) => onChange({ ...filters, ...patch });

  return (
    <div className="em-panel" style={{ marginBottom: 14 }}>
      <div className="em-filters">
        <div className="em-field">
          <label>Search</label>
          <div style={{ position: "relative" }}>
            <FiSearch style={{ position: "absolute", left: 12, top: 13, color: "var(--em-muted)" }} />
            <input
              type="text"
              className="em-input"
              style={{ paddingLeft: 36 }}
              placeholder="Search error message, endpoint or ID"
              value={filters.search || ""}
              onChange={(e) => update({ search: e.target.value })}
            />
          </div>
        </div>

        <div className="em-field">
          <label>Vendor</label>
          <select className="em-input em-select" value={filters.vendor || ""} onChange={(e) => update({ vendor: e.target.value })}>
            <option value="">All</option>
            {vendors.map((v) => (
              <option key={v} value={v}>
                {v}
              </option>
            ))}
          </select>
        </div>

        <div className="em-field">
          <label>Module</label>
          <select
            className="em-input em-select"
            value={filters.module || ""}
            onChange={(e) => update({ module: e.target.value })}
          >
            <option value="">All</option>
            {modules.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>
        </div>

        <div className="em-field">
          <label>Severity</label>
          <select
            className="em-input em-select"
            value={filters.severity || ""}
            onChange={(e) => update({ severity: e.target.value })}
          >
            <option value="">All</option>
            {severities.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>

        <div className="em-field">
          <label>Status</label>
          <select className="em-input em-select" value={filters.status || ""} onChange={(e) => update({ status: e.target.value })}>
            <option value="">All</option>
            {statuses.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>

        <div className="em-field">
          <button className={`em-btn ${filters?.frequent ? 'em-btn-active' : ""}`} onClick={(e)=>update({frequent : !filters?.frequent})}><ArrowUpIcon/> Most Frequent</button>
          {/* <label>Vendor</label>
          <select className="em-input em-select" value={filters.vendor || ""} onChange={(e) => update({ vendor: e.target.value })}>
            <option value="">All</option>
            {vendors.map((v) => (
              <option key={v} value={v}>
                {v}
              </option>
            ))}
          </select> */}
        </div>

      </div>
    </div>
  );
};

export default ErrorFilters;

